export const REGISTER_STATUS = {
  success: "register success",
  faild: "register faild",
}

export const LOGIN_STATUS = {
  success: "login success",
  faild: "login faild",
}

export const OTP_STATUS = {
  success: "otp success",
  faild: "otp faild",
}

export const FORGET_PASSWORD_STATUS = {
  success: "forget password success",
  faild: "forget password faild",
}

export const RESET_PASSWORD_STATUS = {
  success: "reset password success",
  faild: "reset password faild",
}

export const VERIFY_TOKEN_STATUS = {
  success: "verify reset password token success",
  faild: "verify reset password token faild",
}